export enum PromoType {
	TNC_PGNC = 'TNC-PGNC',
	TNC_PGC = 'TNC-PGC',
	PGNC = 'PGNC',
	PGC = 'PGC',
	PG = 'PG',
}

export const FREE_GIFT_IDS = {
	block: 'freeProductPromoBlock',
	ctaOpenDrawer: 'freeProductOpenDrawer',
	ctaEditDrawer: 'freeProductEditDrawer',
	triggerSection: 'freeProductTriggerSection',
	promotionQuantity: 'freeProductPromoQuantity',
	giftSection: 'freeProductGiftSection',
	stickyContainer: 'freeProductSticky',
	addPromoToCart: 'addFPPromoToCart',
	savingsLabel: 'freeProductSavings',
	totalProductLabel: 'freeProductTotal',
	promotionList: 'freeProductPromotionList',
	promotionListIntro: 'freeProductPromotionListIntro',
	backButton: 'freeProductPromotionBack',
	promotionListReward: 'freeGiftPromotionList',
	promotionListIntroReward: 'freeGiftPromotionListIntro',
	backButtonReward: 'freeGiftPromotionBack',
} as const;

export const FREE_GIFT_CLASSES = {
	fpTrigger: 'free-product__trigger',
	fpGift: 'free-product__gift',
	productImage: 'product-image',
	productBrand: 'product-brand',
	productName: 'product-name',
	productSku: 'product-sku',
	productPrice: 'product-price',
	productQuantity: 'product-quantity',
	promotionSelected: 'promotion-selected',
	promoCard: 'promotion-card',
	promoCardTitle: 'promotion-card__title',
	promoCardThumbnails: 'promotion-card__thumbnails',
	promoCardChevron: 'promotion-card__chevron',
} as const;

export const MAX_QTY = 9999;
